import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-moxie-animated',
  templateUrl: './moxie-animated.component.html',
  styleUrls: ['./moxie-animated.component.css']
})
export class MoxieAnimatedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
